import { Box, Select, SelectChangeEvent, MenuItem } from "@mui/material";
import "./MetricCard.scss";
import { RollingNumberLoader } from "../NumberLoader/NumberLoader";
import { ChevronDown } from "lucide-react";
import { Typography } from "antd";

interface MetricCardProps {
  metric: any;
}

interface Option {
  id: number;
  name: string;
}

export default function MetricCard({ metric }: MetricCardProps) {
  const cardClass = `metricCard ${metric.id}`;
  const frameClass = `metricCard__frame-${metric.id}`;

  const monthArray: Option[] = Array.from({ length: 12 }, (_, i) => ({
    id: i + 1,
    name: capitalize(new Date(0, i).toLocaleString("es-ES", { month: "long" })),
  }));

  function capitalize(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const cardLabelMonthId = `metricCard-${metric.id}-month-label`;
  const cardLabelYearId = `metricCard-${metric.id}-year-label`;

  const handleMonthChange = (event: SelectChangeEvent) => {
    metric.setMonthValue(event.target.value);
  };
  const handleYearChange = (event: SelectChangeEvent) => {
    metric.setYearValue(event.target.value);
  };

  return (
    <Box className={cardClass}>
      <Box className="metricCard__content">
        <Box className="metricCard__content__header">
          <Box className="metricCard__content__header__iconBox">
            {metric.icon}
          </Box>
          <Box className="metricCard__content__header__name">{metric.name}</Box>
          <Box className="metricCard__content__header__controls">
            {metric.hasMonthFilter && (
              <Select
                className="metricCard__content__header__controls__month"
                id={cardLabelMonthId}
                value={metric.monthValue}
                IconComponent={(props) => <ChevronDown {...props} />}
                onChange={handleMonthChange}
                label="Mes"
              >
                <MenuItem value={0}>Mes</MenuItem>
                {monthArray.map((month, index) => (
                  <MenuItem key={index + 1} value={month.id}>
                    {month.name}
                  </MenuItem>
                ))}
              </Select>
            )}
            {metric.hasYearFilter && (
              <Select
                className="metricCard__content__header__controls__year"
                id={cardLabelYearId}
                value={metric.yearValue}
                onChange={handleYearChange}
                label="Año"
                IconComponent={(props) => <ChevronDown {...props} />}
              >
                <MenuItem value={0}>Año</MenuItem>
                {metric?.yearsData?.map((year: any, index: number) => (
                  <MenuItem key={index + 1} value={year.id}>
                    {year.name}
                  </MenuItem>
                ))}
              </Select>
            )}
          </Box>
        </Box>
        <Box className="metricCard__content__body">
          {!metric.isLoading ? (
            <Box className="metricCard__content__body__data">
              {metric.value}
            </Box>
          ) : (
            <Box className="metricCard__content__body">
              <Box className="metricCard__content__body__data">
                <RollingNumberLoader isLoading={metric.isLoading} />
              </Box>
            </Box>
          )}
        </Box>
      </Box>
      <Box className={frameClass} />
    </Box>
  );
}
